import React from "react";
import StatCard from "components/card/StatCard";
import ProductTable from "views/admin/products/components/Producttable";
import { columnsDataComplex } from "views/admin/products/variables/columnsData";

export default function Products() {
  return (
    <div className="min-h-screen bg-neutral-950 text-gray-100 px-0 pt-0 pb-10 space-y-10">
      {/* 📊 상단 통계 카드 */}
     

      {/* 🧾 제품 테이블 */}
      <div className="bg-[#121212] rounded-2xl border border-[#1e1e1e] shadow-lg p-6 mt-0">
        <h2 className="text-xl font-bold mb-4">Product Performance</h2>
        <p className="text-sm text-gray-400 mb-6">
          Check detailed stats and adjust forecasts below.
        </p>
        <ProductTable columnsData={columnsDataComplex} />
      </div>
    </div>
  );
}